import "core-js/modules/es.promise.js";
import { uniCall } from '../../utils';
/**
 * 拉起微信小程序
 */

export function launchMiniProgram(option) {
  return new Promise(function (resolve) {
    var params = JSON.stringify(option);
    uniCall({
      api: 'launchMiniProgram',
      param: params
    });
    resolve();
  });
}
/**
 * 拉起微信小程序
 * @deprecated Use `launchMiniProgram` instead
 */

export var openMiniProgram = launchMiniProgram;